import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider } from "@/lib/auth";
import AppLayout from "@/components/AppLayout";
import AuthPage from "@/pages/AuthPage";
import DashboardPage from "@/pages/DashboardPage";
import TradePage from "@/pages/TradePage";
import PositionsPage from "@/pages/PositionsPage";
import HistoryPage from "@/pages/HistoryPage";
import WatchlistPage from "@/pages/WatchlistPage";
import BotsPage from "@/pages/BotsPage";
import LeaderboardPage from "@/pages/LeaderboardPage";
import NotificationsPage from "@/pages/NotificationsPage";
import PublicBotPage from "@/pages/PublicBotPage";
import PublicTraderPage from "@/pages/PublicTraderPage";
import LandingPage from "@/pages/LandingPage";
import BrokerPage from "@/pages/BrokerPage";

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<AuthPage mode="login" />} />
            <Route path="/register" element={<AuthPage mode="register" />} />
            <Route path="/b/:botId" element={<PublicBotPage />} />
            <Route path="/t/:tag" element={<PublicTraderPage />} />
            <Route element={<AppLayout />}>
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/trade" element={<TradePage />} />
              <Route path="/positions" element={<PositionsPage />} />
              <Route path="/history" element={<HistoryPage />} />
              <Route path="/watchlist" element={<WatchlistPage />} />
              <Route path="/bots" element={<BotsPage />} />
              <Route path="/leaderboard" element={<LeaderboardPage />} />
              <Route path="/notifications" element={<NotificationsPage />} />
              <Route path="/broker" element={<BrokerPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster
          position="bottom-right"
          theme="dark"
          toastOptions={{
            style: {
              background: "#18181b",
              border: "1px solid #27272a",
              borderRadius: "2px",
              fontFamily: "JetBrains Mono",
              fontSize: 12,
              color: "#fff",
            },
          }}
        />
      </AuthProvider>
    </div>
  );
}
